<template>
  <empty-layout>
    <div
      v-if="!loading"
      class="w-[100vw] h-[100svh] fixed top-0 left-0 right-0 bottom-0"
    >
      <div
        class="close-btn absolute cursor-pointer z-50 mx-[24px] md:mx-[32px] lg:ml-[56px] pt-4"
        @click="back"
      >
        <img src="../../../public/assets/icons/go-back-chevron.svg" />
      </div>
      <iframe
        :src="src"
        :key="iframeKey"
        title="GenerationS Implementation Community"
        onload="window.parent.scrollTo(0,0)"
        class="w-[100vw] h-[100svh] overflow-auto"
      ></iframe>
    </div>
    <div v-else class="w-screen h-screen flex items-center justify-center">
      <loading-state></loading-state>
    </div>
  </empty-layout>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import EmptyLayout from "@/components/EmptyLayout.vue";
import LoadingState from "@/components/common/LoadingState.vue";

export default {
  layout: "form-empty",
  components: {
    EmptyLayout,
    LoadingState,
  },
  data() {
    return {
      surveyId: "",
      iframeKey: 0,
      loading: true,
    };
  },
  async ionViewDidEnter() {
    this.loading = true;
    await this.$store.dispatch("profile/fetchProfile");
    this.loading = false;
  },
  computed: {
    ...mapState("profile", [
      "id",
      "name",
      "organization",
      "email",
      "country",
      "groupName",
      "preferredName",
    ]),
    encodedEmail() {
      return encodeURIComponent(this.email);
    },
    encodedName() {
      if (!this.name) return "";
      return encodeURIComponent(this.name);
    },
    encodedPreferredName() {
      if (!this.preferredName) return "";
      return encodeURIComponent(this.preferredName);
    },
    encodedOrganization() {
      if (!this.organization) return "";
      return encodeURIComponent(this.organization);
    },
    encodedCountry() {
      if (!this.country) return "";
      return encodeURIComponent(this.country);
    },
    encodedGroupName() {
      if (!this.groupName) return "";
      return encodeURIComponent(this.groupName);
    },
    src() {
      const url = `https://${this.surveyId}.paperform.co?login=true&id=${this.id}&name=${this.encodedName}&organization=${this.encodedOrganization}&email=${this.encodedEmail}&country=${this.encodedCountry}&teamId=${this.encodedGroupName}&preferredName=${this.preferredName}`;
      return url;
    },
  },
  ionViewWillEnter() {
    this.surveyId = this.$route.params.name;
    this.iframeKey = this.iframeKey + 1;
  },
  methods: {
    back() {
      this.$router.push("/whats-next");
    },
  },
};
</script>
